import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const visualTools = ['Step-by-step visual sequences', 'Movement arrows', 'Position maps', 'Decision trees', 'Correct-vs-incorrect comparisons', 'Progression systems', 'Coaching cue cards', 'Reaction branches', 'Drill setups', 'Session structures'];
export function VisualCoaching() {
  return <section className="py-24 px-4 bg-white" data-id="element-295" data-mp="1tddqe1fd0llu">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-5xl mx-auto grid md:grid-cols-5 gap-10 md:gap-14 items-start" data-id="element-296" data-mp="1tc2m80i05bu7">
        <div className="md:col-span-2" data-id="element-297" data-mp="1y5nkzurf69ug">
          <p className="font-display font-extrabold uppercase tracking-wide text-sm text-violet-600 mb-3" data-id="element-298" data-mp="2d1whwpnu8b3p">
            Not another theory PDF
          </p>
          <h2 className="text-3xl md:text-4xl font-black uppercase text-zinc-950 mb-5" data-id="element-299" data-mp="284wdej6mzgep">
            See it. Understand it. Coach it.
          </h2>
          <p className="text-lg text-zinc-700 mb-4" data-id="element-300" data-mp="3l4e7l7sszg76">
            MMA Coach Ready is designed around visual coaching.
          </p>
          <p className="text-lg text-zinc-700" data-id="element-301" data-mp="3p5q1hpipmnl6">
            You should not have to read ten pages of theory before understanding how to run a drill.
          </p>
          <p className="text-2xl font-display font-black uppercase text-violet-900 mt-6" data-id="element-302" data-mp="2zt30vwj84kh">
            Open the page and use it.
          </p>
        </div>

        <div className="md:col-span-3 bg-zinc-100 border border-zinc-200 rounded-2xl p-6 md:p-8" data-id="element-303" data-mp="7wjef5xe6bzk">
          <h3 className="text-lg font-extrabold uppercase text-zinc-950 mb-5" data-id="element-304" data-mp="cpw29du8yer9">
            That means the system uses:
          </h3>
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-305" data-mp="lq0zww9n1ys8">
            {visualTools.map(tool => <li key={tool} className="flex items-start gap-3" data-id="element-306" data-mp="qocaj97rcdbi">
                <CheckCircle2 size={18} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-307" data-mp="qmrcvaq5ce9f" />
                <span className="text-zinc-700" data-id="element-308" data-mp="2mpns70oyjt9b">{tool}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </section>;
}